import React, { useState } from 'react'
import { Alert, Button, Card, CloseButton, Container, Form, InputGroup } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom';
import { serIsForAnswer, serIsForEmail, serIsForTel } from '../../axios';
import langList from '../../utils/languagelist.json'
import { useSelector } from 'react-redux';

export default function Register() {

  const [currentCardId, setCurrentCardId] = useState(0);
  const [inputValues, setInputValues] = useState(Array(4).fill(''));
  const [msgError, setMsgError] = useState('');
  const {lg}=useSelector((state)=>state.language)

  const handleInputChange = (index,value) => { 
    const newInputValues=[...inputValues];
    newInputValues[index]=value;
    setInputValues(newInputValues);
  }

  const handleNextClick = () => {
    if(msgError){
      return;
    };
    switch (currentCardId) {
      case 0:{
        if(inputValues[0].trim()===''){
          return;
        };
        const regex = /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/;
        if(!regex.test(inputValues[0])){
          setMsgError(`${langList.permission2[lg]}`);
          return;
        };
        serIsForEmail({eml:inputValues[0]})
        .then(res =>{
          const code=res.code;
          if(code===15){
            setMsgError(`${langList.crsytal3[lg]}`);
            return;
          };
          if (currentCardId < cardContents.length - 1) {
            setCurrentCardId(currentCardId + 1);
          };
        })
        .catch(err =>{
          setMsgError(err.message);
        });
        break;
      }
      case 1:{
        if(inputValues[1].trim()===''){
          return;
        };
        const regex=/^(\+?\d{1,3}\s?)?(\()?\d{1,4}(\))?[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/;
        if(!regex.test(inputValues[1])){
          setMsgError(`${langList.getpwd1[lg]}`);
          return;
        };
        if(inputValues[1].length>18){
          setMsgError(`${langList.getpwd1[lg]}`);
          return;
        }
        serIsForTel({eml:inputValues[0],tel:inputValues[1]})
        .then(res =>{
          const code=res.code;
          const data=res.data
          if(code===17){
            setMsgError(`${langList.getpwd1[lg]}`);
            return;
          };
          if (currentCardId < cardContents.length - 1) {
            setCurrentCardId(currentCardId + 1);
          };
          handleInputChange(2,data);
        })
        .catch(err =>{
          setMsgError(err.message);
        });
        break;
      }
      case 2:{
        if(inputValues[3].trim()===''){
          return;
        };
        if(inputValues[3].length>18){
          setMsgError(`${langList.getpwd2[lg]}`);
          return;
        };
        serIsForAnswer({inp:inputValues})
        .then(res =>{
          const code=res.code;
          if(code===19){
            setMsgError(`${langList.getpwd2[lg]}`);
            return;
          };
          if (currentCardId < cardContents.length - 1) {
            setCurrentCardId(currentCardId + 1);
          };
        })
        .catch(err =>{
          setMsgError(err.message);
        });
        break;
      }      
    default:
      break;
  }
  };

  const handlePrevClick = () => {
    if (currentCardId > 0) {
      setCurrentCardId(currentCardId - 1);
    }
  };

  const navigate=useNavigate();
  const closeBtnClick = () => {
    navigate('/',{replace:true});
  };
  const handleToLogin = ()=>{
    navigate('/login',{replace:true});
  }
    
  const card1=(
    <div>
      <div className='py-4'>
        <h3>{langList.public4[lg]}</h3>
      </div>
      <InputGroup size="lg" className="mb-2">
        <InputGroup.Text>
          <img src='./pic/person.svg' alt=''/>
        </InputGroup.Text>
        <Form.Control
          id='card1-0'
          type="text"
          placeholder={langList.public4[lg]}
          value={inputValues[0]}
          onChange={e=>{handleInputChange(0,e.target.value)}}
        />
      </InputGroup>
      <div className='pb-5 mb-3 position-relative'>
        <Alert 
          show={msgError===''?false:true} 
          variant={'danger'} 
          className='py-1 text-center text-danger position-absolute w-100'
        >
          {msgError}
        </Alert>
      </div>
      <Card.Title className='ps-3'>{langList.getpwd3[lg]}</Card.Title>
      <ul>
        <li>{langList.getpwd4[lg]}</li>
      </ul>
    </div>
  );

  const card2=(
    <div>
      <div className='py-4'>
        <h3>{langList.getpwd5[lg]}</h3>
      </div>
      <InputGroup size="lg" className="mb-2">
        <InputGroup.Text>
          <img src='./pic/telephone.svg' alt=''/>
        </InputGroup.Text>
        <Form.Control
          id='card2-0'
          type='text'
          placeholder={langList.getpwd5[lg]}
          value={inputValues[1]}
          onChange={e=>{handleInputChange(1,e.target.value)}}
        />
      </InputGroup>
      <div className='pb-5 mb-3 position-relative'>
        <Alert 
          show={msgError===''?false:true} 
          variant={'danger'} 
          className='py-1 text-center text-danger position-absolute w-100'
        >
          {msgError}
        </Alert>
      </div>
      <Card.Title className='ps-3'>{langList.getpwd3[lg]}</Card.Title>
      <ul>
        <li>{langList.getpwd6[lg]}</li>
      </ul>
    </div>
  );
  
  const card3=(
    <div>
      <div className='py-4'>
        <h3>{langList.getpwd7[lg]}</h3>
      </div>
      <InputGroup size="lg" className="mb-3">
        <InputGroup.Text>
          <img src='./pic/chat-text.svg' alt=''/>
        </InputGroup.Text>
        <Form.Control
          id='card5-0'
          as="textarea"
          type='text'
          value={inputValues[2]}
          disabled
        />
      </InputGroup>
      <InputGroup size="lg" className="mb-1">
        <InputGroup.Text className='px-3'>
          <img src='./pic/check-circle.svg' alt=''/>
        </InputGroup.Text>
        <Form.Control
          id='card5-1'
          type='text'
          placeholder={langList.getpwd8[lg]}
          value={inputValues[3]}
          onChange={e=>{handleInputChange(3,e.target.value)}}
        />
      </InputGroup>
      <div className='pb-4 position-relative'>
        <Alert 
          show={msgError===''?false:true} 
          variant={'danger'} 
          className='py-1 text-center text-danger position-absolute w-100'
        >
          {msgError}
        </Alert>
      </div>
      <Card.Title className='ps-3 pt-3'>{langList.getpwd3[lg]}</Card.Title>
      <ul>
        <li>{langList.getpwd9[lg]}</li>
      </ul>
    </div>
  );

  const card4=(
    <div>
      <div className='py-4'>
        <h3>{langList.getpwd10[lg]}</h3>
      </div>
      <Card.Title className='ps-3 pt-3'>{langList.getpwd3[lg]}</Card.Title>
      <ul>
        <li>{langList.getpwd11[lg]}{inputValues[0]}</li>
        <li>{langList.getpwd12[lg]}</li>
      </ul>
    </div>
  );

  const cardContents = [card1,card2,card3,card4];

  if(msgError){
    setTimeout(() => {
      setMsgError('');
    }, 5000);
  };

  return (
    <Container className='d-flex justify-content-center align-items-center' style={{height:'100vh'}}>
      <Card className='shadow' style={{maxWidth:'25rem',width:'100%'}}>
        <Card.Header className='d-flex justify-content-between align-items-center py-3'>
          <span>{langList.login5[lg]}</span>
          <CloseButton onClick={closeBtnClick}/>
        </Card.Header>
        <Card.Body>
          {cardContents[currentCardId]}
        </Card.Body>
        <Card.Footer className='py-3'>
          {currentCardId ===0 &&
          <div className='d-flex justify-content-between align-items-center'>
            <div></div>
            <Button
              variant="primary"
              className='w-auto'
              onClick={handleNextClick}
            >{langList.getpwd13[lg]}</Button>
          </div>
          }
          {currentCardId !==0 &&
          currentCardId !== cardContents.length-2 &&
          currentCardId !== cardContents.length-1 &&
          <div className='d-flex justify-content-between align-items-center'>
            <Button
              variant="primary"
              className='w-auto'
              onClick={handlePrevClick}
            >{langList.getpwd14[lg]}</Button>
            <div></div>
            <Button
              variant="primary"
              className='w-auto'
              onClick={handleNextClick}
            >{langList.getpwd13[lg]}</Button>
          </div>
          }
          {currentCardId === cardContents.length-2 &&
          <div className='d-flex justify-content-between align-items-center'>
            <Button
              variant="primary"
              className='w-auto'
              onClick={handlePrevClick}
            >{langList.getpwd14[lg]}</Button>
            <div></div>
            <Button
              variant="primary"
              className='w-auto'
              onClick={handleNextClick}
            >{langList.getpwd15[lg]}</Button>
          </div>
          }
          {currentCardId === cardContents.length-1 &&
          <div className='d-flex justify-content-center align-items-center'>
            <Button
              variant="primary"
              className='w-auto'
              onClick={handleToLogin}
            >{langList.getpwd16[lg]}</Button>
          </div>
          }
        </Card.Footer>
      </Card>
    </Container>
  )
}
